import axios from 'axios';

const REGULATORY_DOCS_SECONDARY = {
  DOC_SECONDARY_LIST_REQUEST: '@@docs_secondary/DOC_SECONDARY_LIST_REQUEST',
  DOC_SECONDARY_LIST_REQUEST_SUCCESS: '@@docs_secondary/DOC_SECONDARY_LIST_REQUEST_SUCCESS',
  DOC_SECONDARY_LIST_REQUEST_ERROR: '@@docs_secondary/DOC_SECONDARY_LIST_REQUEST_ERROR',

  DOC_SECONDARY_LOAD_REQUEST: '@@docs_secondary/DOC_SECONDARY_LOAD_REQUEST',
  DOC_SECONDARY_LOAD_REQUEST_SUCCESS: '@@docs_secondary/DOC_SECONDARY_LOAD_REQUEST_SUCCESS',
  DOC_SECONDARY_LOAD_REQUEST_ERROR: '@@docs_secondary/DOC_SECONDARY_LOAD_REQUEST_ERROR',

  DOC_SECONDARY_UPDATE_REQUEST: '@@docs_secondary/DOC_SECONDARY_UPDATE_REQUEST',
  DOC_SECONDARY_UPDATE_REQUEST_SUCCESS: '@@docs_secondary/DOC_SECONDARY_UPDATE_REQUEST_SUCCESS',
  DOC_SECONDARY_UPDATE_REQUEST_ERROR: '@@docs_secondary/DOC_SECONDARY_UPDATE_REQUEST_ERROR',

  DOC_SECONDARY_REMOVE_REQUEST: '@@docs_secondary/DOC_SECONDARY_REMOVE_REQUEST',
  DOC_SECONDARY_REMOVE_REQUEST_SUCCESS: '@@docs_secondary/DOC_SECONDARY_REMOVE_REQUEST_SUCCESS',
  DOC_SECONDARY_REMOVE_REQUEST_ERROR: '@@docs_secondary/DOC_SECONDARY_REMOVE_REQUEST_ERROR',
}

const initialState = {
  error: null,
  busy: false,
  list: [],
  current: null
};

const RegulatoryDocsSecondaryReducer = (state = initialState, action) => {
  switch (action.type) {
    case REGULATORY_DOCS_SECONDARY.DOC_SECONDARY_LIST_REQUEST:
    case REGULATORY_DOCS_SECONDARY.DOC_SECONDARY_LOAD_REQUEST:
    case REGULATORY_DOCS_SECONDARY.DOC_SECONDARY_UPDATE_REQUEST:
    case REGULATORY_DOCS_SECONDARY.DOC_SECONDARY_REMOVE_REQUEST:
      return {
        ...state,
        busy: true,
        error: null
      };
    case REGULATORY_DOCS_SECONDARY.DOC_SECONDARY_LIST_REQUEST_SUCCESS:
      return {
        ...state,
        busy: false,
        list: action.payload
      };
    case REGULATORY_DOCS_SECONDARY.DOC_SECONDARY_LOAD_REQUEST_SUCCESS:
      return {
        ...state,
        current: action.payload,
        busy: false,
      }
    case REGULATORY_DOCS_SECONDARY.DOC_SECONDARY_UPDATE_REQUEST_SUCCESS:
      return {
        ...state,
        current: action.payload,
        list: state.list.map(doc => doc.name === action.payload.name ? action.payload : doc),
        busy: false
      }
    case REGULATORY_DOCS_SECONDARY.DOC_SECONDARY_REMOVE_REQUEST_SUCCESS:
      return {
        ...state,
        current: action.payload,
        list: state.list.map(doc => doc.name === action.payload.name ? action.payload : doc),
        busy: false
      }
    case REGULATORY_DOCS_SECONDARY.DOC_SECONDARY_LIST_REQUEST_ERROR:
    case REGULATORY_DOCS_SECONDARY.DOC_SECONDARY_LOAD_REQUEST_ERROR:
    case REGULATORY_DOCS_SECONDARY.DOC_SECONDARY_UPDATE_REQUEST_ERROR:
    case REGULATORY_DOCS_SECONDARY.DOC_SECONDARY_REMOVE_REQUEST_ERROR:
      return {
        ...state,
        error: action.payload,
        busy: false
      }
    default:
      return state;
  }
}

export default RegulatoryDocsSecondaryReducer;

export const loadRegulatoryDocsSecondary = () => dispatch => {
  dispatch({ type: REGULATORY_DOCS_SECONDARY.DOC_SECONDARY_LIST_REQUEST });
  axios.get('/api/statistics/regulatory-docs/secondary/')
    .then(({ data: payload }) => {
      dispatch({
        type: REGULATORY_DOCS_SECONDARY.DOC_SECONDARY_LIST_REQUEST_SUCCESS,
        payload
      });
    })
    .catch(error => {
      dispatch({
        type: REGULATORY_DOCS_SECONDARY.ERROR,
        payload: error
      })
    })
}

export const loadRegulatoryDocSecondary = (category_name) => dispatch => {
  dispatch({ type: REGULATORY_DOCS_SECONDARY.DOC_SECONDARY_LOAD_REQUEST });
  axios.get(`/api/statistics/regulatory-docs/secondary/${category_name}/`)
    .then(({ data: payload }) => {
      dispatch({
        type: REGULATORY_DOCS_SECONDARY.DOC_SECONDARY_LOAD_REQUEST_SUCCESS,
        payload
      })
    }).catch(error => {
    dispatch({
      type: REGULATORY_DOCS_SECONDARY.DOC_SECONDARY_LOAD_REQUEST_ERROR,
      payload: error
    })
  })
}

export const updateRegulatoryDocSecondary = (data) => dispatch => {
  dispatch({ type: REGULATORY_DOCS_SECONDARY.DOC_SECONDARY_UPDATE_REQUEST });
  axios.put(`/api/statistics/regulatory-docs/secondary/${ data.name }/`,  data)
    .then(({ data: payload }) => {
      dispatch({
        type: REGULATORY_DOCS_SECONDARY.DOC_SECONDARY_UPDATE_REQUEST_SUCCESS,
        payload
      })
    })
    .catch(error => {
      dispatch({
        type: REGULATORY_DOCS_SECONDARY.DOC_SECONDARY_UPDATE_REQUEST_ERROR,
        payload: error
      })
    })
}

export const removeRegulatoryDocSecondary = ({ name }) => dispatch => {
  dispatch({ type: REGULATORY_DOCS_SECONDARY.DOC_SECONDARY_REMOVE_REQUEST });
  axios.delete(`/api/statistics/regulatory-docs/secondary/${ name }/`)
    .then(({ data: payload }) => {
      dispatch({
        type: REGULATORY_DOCS_SECONDARY.DOC_SECONDARY_REMOVE_REQUEST_SUCCESS,
        payload
      })
    })
    .catch(error => {
      dispatch({
        type: REGULATORY_DOCS_SECONDARY.DOC_SECONDARY_REMOVE_REQUEST_ERROR,
        payload: error
      })
    })
}
